import { init } from "./js/controllers/add-new-stick";

(function () {
  init();
})();
